import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Settings } from "@/types";
import { fetchSettings } from "./thunk";

export interface SettingsState {
  settings: Partial<Settings>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: SettingsState = {
  settings: {},
  error: null,
  status: "idle"
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[settingsSlice.name]
        };
      })
      .addCase(fetchSettings.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.status = "idle";
        state.settings = action.payload;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
